import {useScanProductInContainer} from './ScanProductInContainer.hook'
import { AtlasH1, AtlasH2, Filler, Icons, PageContentAtom, ToolbarMolecule} from '@justomx/atlas-components'

export const ScanProductInContainerPages = () => {
  const {actions} = useScanProductInContainer()

  return <>
    <ToolbarMolecule title='Escanea'
                     actionIcon={Icons.ArrowBack}
                     onAction={actions.back}
                     data-test='scan-product-toolbar'/>
    <PageContentAtom $centered>
      <Filler flexGrow={1}/>
      <AtlasH2>Escanea</AtlasH2>
      <AtlasH1 style={{textAlign: 'center'}}>Producto</AtlasH1>
      <Filler/>
    </PageContentAtom>
  </>
}
